import { DatePicker } from "antd"

const CustomYearPicker = ({ onChange }) => {

    const yearPickerValue = (date, dateString) => {
        onChange(dateString)
    }
    return (
        <DatePicker onChange={yearPickerValue} inputReadOnly={true} className='w-full h-10 outline-none border-none custom-card-boxshadow' picker="year" />
    )
}

export default CustomYearPicker